import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import {useSelector} from "react-redux";
import {useAxiosIndicatorCheck} from 'src/store/hook/useAxiosIndicatorCheck';
import AxiosIndicatorRunTimeLoader from "./AxiosIndicatorRunTimeLoader";

export function AxiosSingletonLoader(props) {
    const {slugKey, validQuoteCount} = props;
    const refLoad = useRef();
    const [load, setLoad] = useState(false);
    const [__check] = useAxiosIndicatorCheck();
    const axios_indicator = useSelector((state) => state.entities.system.axios_indicator);
    useEffect(() => {
        let status = __check(slugKey).status;
        if (status === true && load === true) {
            refLoad.current.style.display = 'none';
        } else {
            refLoad.current.style.display = '';
            setLoad(false)
        }
    }, [axios_indicator])
    const customAxiosIndicatorRunTimeLoader = () => {
        return (
            load === true &&
            <a href={void (0)} disabled={true}
               className={"bs5 btn btn-primary btn-sm w-100 disabled"}>
                <i className="fa fa-spinner fa-spin"/>
            </a>
        )
    };
    return (
        <>
            {load === true &&
            <>
                {props.customAxiosIndicatorRunTimeLoader !== undefined &&
                <>
                    {React.createElement(props.customAxiosIndicatorRunTimeLoader)}
                </>
                }
                {props.customAxiosButtonIndicatorRunTimeLoader !== undefined &&
                <>
                    {customAxiosIndicatorRunTimeLoader()}
                </>
                }
                {props.customAxiosButtonIndicatorRunTimeLoader === undefined &&
                <>
                    {props.customAxiosIndicatorRunTimeLoader === undefined &&
                    <>
                        <AxiosIndicatorRunTimeLoader {...props}/>
                    </>
                    }
                </>
                }
            </>
            }
            <div ref={refLoad} onClick={() => {
                if (props.disabled !== undefined && props.disabled === true) {
                    return false;
                }
                refLoad.current.style.display = 'none';
                validQuoteCount === undefined ? setLoad(true) : validQuoteCount !== undefined && validQuoteCount !== null && validQuoteCount > 0 ? setLoad(true) : setLoad(false)
            }}>
                {props.children}
            </div>
        </>
    );
}

export default AxiosSingletonLoader;